<!--离职继承--->
<template>
    <!--有分配权限--->
    <div class="page flex-col">
        <div class="group_1 flex-col justify-between"
            v-if="this.quitdata.postId =='1'||this.quitdata.postId =='1472787652026765367' ">
            <div class="box_4 flex-col" @click="toManageInheritanceRecord()">
                <div class="box_5 flex-row justify-between">
                    <span class="text_4">我继承的顾客与顾客群</span>
                    <div class="box_6 flex-col"></div>
                </div>
            </div>
        </div>
        <div class="group_2 flex-col">
            <div class="group_3 flex-row justify-between">
                <img class="label_4" referrerpolicy="no-referrer"
                    src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/assignment.png"
                    alt="" />
                <span class="text_5">成员离职后，可以将他的客户和客户群分配给其他成员跟进并继续提供服务</span>
            </div>
        </div>
        <!--有分配权限且没有待分配离职员工--->
        <div class="group_4 flex-col"
            v-if="(this.quitdata.postId =='1' ||this.quitdata.postId =='1472787652026765367' ) && this.quitdata.resEmpCount == '0' ">
            <div class="block_1 flex-col">
                <span class="text_6">无离职成员需分配</span>
                <div class="group_5 flex-col">
                </div>
                <div class="group_6 flex-row" @click="toAllocationRecord()">
                    <img class="label_5" referrerpolicy="no-referrer"
                        src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/record.png"
                        alt="" />
                    <span class="text_7">分配记录</span>
                    <div class="block_2 flex-col"></div>
                </div>
            </div>
        </div>
        <!--有分配权限且有待分配离职员工--->
        <div class="lizhi_group_5 flex-col"
            v-if="(this.quitdata.postId=='1' ||this.quitdata.postId=='1472787652026765367' )  && this.quitdata.resEmpCount > 0  ">
            <div class="lizhi_block_2 flex-col">
                <span class="lizhi_text_6">{{this.quitdata.resEmpCount}}名离职成员</span>
                <span class="lizhi_text_7">{{this.quitdata.contactCount}}位顾客，{{this.quitdata.groupCount}}个顾客群</span>
                <div class="lizhi_text-wrapper_2 flex-col" @click="toDistribution()">
                    <span class="lizhi_text_8">去分配</span>
                </div>
                <div class="lizhi_group_6 flex-col"></div>
                <div class="lizhi_group_7 flex-row" @click="toAllocationRecord()">
                    <img class="lizhi_label_5" referrerpolicy="no-referrer"
                        src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/record.png"
                        alt="" />
                    <span class="lizhi_text_9">分配记录</span>
                    <div class="lizhi_box_5 flex-col"></div>
                </div>
            </div>
        </div>
        <!--无分配权限仅查看自己的继承信息--->
        <div class="zaizhi_group_5 flex-col" v-if="this.quitdata.postId !='1' ||this.quitdata.postId!='1472787652026765367' ">
            <div class="zaizhi_group_6 flex-col">
                <span class="zaizhi_text_5">我继承了离职成员的</span>
                <div class="zaizhi_list_1 flex-row">
                    <div class="zaizhi_list-items_1 flex-col">
                        <div class="zaizhi_list-items_1 flex-col">
                            <span class="zaizhi_text_6">{{quitdata.myselfResConCount}}</span>
                            <span class="zaizhi_text_8">顾客</span>
                        </div>
                    </div>
                    <div class="zaizhi_list-items_1 flex-col">
                        <div class="zaizhi_list-items_1 flex-col">
                            <span class="zaizhi_text_7">{{quitdata.myselfResGroCount}}</span>
                            <span class="zaizhi_text_8">顾客群</span>
                        </div>
                    </div>
                </div>
                <div class="zaizhi_box_1 flex-col"></div>
                <div class="zaizhi_box_2 flex-row" @click="toManageInheritanceRecord()">
                    <img class="zaizhi_label_5" referrerpolicy="no-referrer"
                        src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/record.png"
                        alt="" />
                    <span class="zaizhi_text_9">查看详情</span>
                    <div class="zaizhi_block_4 flex-col"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";

export default {
    name: "quitInherit",

    data() {
        return {
            quitdata: [],
            loading: false,
        };
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        onLoad() {
            request({
                url: `/workEmployee/getResEmpIndex`,
                method: "get",
            })
                .then((res) => {
                    this.quitdata = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        //选择离职员工分配
        toDistribution() {
            this.$router.push({
                name: "quitEmployeesList",
                query: {
                    //type: type
                },
            });
        },

        //分配记录
        toAllocationRecord() {
            this.$router.push({
                name: "allocationRecord",
                query: {
                },
            });
        },

        //我继承的顾客与顾客群
        toManageInheritanceRecord() {
            this.$router.push({
                name: "manageInheritanceRecord",
                query: {
                    //type: type
                },
            });
        },


    },
};
</script>

<style scoped>
.box_4 {
    height: 100px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 6px 26px 0px rgba(2, 2, 2, 0.08);
    width: 690px;
    margin: 717px 0 0 30px;
}

.box_5 {
    width: 630px;
    height: 40px;
    margin: 30px 0 0 30px;
}

.text_4 {
    width: 280px;
    height: 40px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 28px;
    white-space: nowrap;
    line-height: 40px;
    text-align: left;
}

.box_6 {
    width: 15px;
    height: 26px;
    background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/arrow.png)
        0px 0px no-repeat;
    background-size: 16px 26px;
    margin-top: 7px;
    margin-left: 334px;
}

.group_2 {
    z-index: 27;
    height: 385px;
    background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/background.png)
        no-repeat;
    background-size: cover;
    width: 750px;
    position: absolute;
    left: 0;
}

.group_3 {
    width: 690px;
    height: 80px;
    margin: 61px 0 0 30px;
}

.label_4 {
    width: 28px;
    height: 29px;
    margin-top: 7px;
}

.text_5 {
    width: 642px;
    height: 80px;
    display: inline-block;
    color: rgba(255, 255, 255, 1);
    font-size: 28px;
    line-height: 40px;
    text-align: left;
    margin-left: 20px;
}

.group_4 {
    z-index: 28;
    height: 477px;
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 6px 26px 0px rgba(2, 2, 2, 0.08);
    width: 690px;
    position: absolute;
    left: 30px;
    top: 201px;
}

.block_1 {
    width: 690px;
    height: 283px;
    margin-top: 164px;
}

.text_6 {
    width: 272px;
    height: 48px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 34px;
    white-space: nowrap;
    line-height: 48px;
    text-align: left;
    margin-left: 209px;
}

.group_5 {
    width: 690px;
    height: 1px;
    background-color: rgba(215, 215, 215, 1);
    margin-top: 164px;
}

.group_6 {
    width: 640px;
    height: 40px;
    margin: 30px 0 0 20px;
}

.label_5 {
    width: 40px;
    height: 40px;
}

.text_7 {
    width: 112px;
    height: 40px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 28px;
    white-space: nowrap;
    line-height: 40px;
    text-align: left;
    margin-left: 10px;
}

.block_2 {
    width: 15px;
    height: 27px;
    background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/arrow.png)
        0px 0px no-repeat;
    background-size: 16px 26px;
    margin: 7px 0 0 463px;
}
.page {
    position: relative;
    width: 750px;
    height: 1630px;
    background-color: rgba(249, 250, 252, 1);
    overflow: hidden;
}

.group_1 {
    width: 750px;
    height: 993px;
}

.lizhi_group_5 {
    z-index: 40;
    height: 477px;
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 6px 26px 0px rgba(2, 2, 2, 0.08);
    width: 690px;
    position: absolute;
    left: 30px;
    top: 201px;
}

.lizhi_block_2 {
    width: 690px;
    height: 367px;
    margin-top: 80px;
}

.lizhi_text_6 {
    width: 191px;
    height: 48px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 34px;
    white-space: nowrap;
    line-height: 48px;
    text-align: left;
    margin-left: 250px;
}

.lizhi_text_7 {
    width: 217px;
    height: 33px;
    display: inline-block;
    color: rgba(160, 172, 181, 1);
    font-size: 24px;
    white-space: nowrap;
    line-height: 33px;
    text-align: left;
    margin: 10px 0 0 237px;
}

.lizhi_text-wrapper_2 {
    height: 88px;
    border-radius: 44px;
    background-color: rgba(51, 63, 72, 1);
    width: 450px;
    margin: 37px 0 0 120px;
}

.lizhi_text_8 {
    width: 99px;
    height: 45px;
    display: inline-block;
    color: rgba(255, 255, 255, 1);
    font-size: 32px;
    letter-spacing: 1px;
    white-space: nowrap;
    line-height: 45px;
    text-align: center;
    margin: 22px 0 0 176px;
}

.lizhi_group_6 {
    width: 690px;
    height: 1px;
    background-color: rgba(215, 215, 215, 1);
    margin-top: 80px;
}

.lizhi_group_7 {
    width: 640px;
    height: 40px;
    margin: 30px 0 0 20px;
}

.lizhi_label_5 {
    width: 40px;
    height: 40px;
}

.lizhi_text_9 {
    width: 112px;
    height: 40px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 28px;
    white-space: nowrap;
    line-height: 40px;
    text-align: left;
    margin-left: 10px;
}

.lizhi_box_5 {
    width: 15px;
    height: 27px;
    background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/arrow.png)
        0px 0px no-repeat;
    background-size: 16px 26px;
    margin: 7px 0 0 463px;
}

.zaizhi_group_5 {
    z-index: 28;
    height: 469px;
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 6px 26px 0px rgba(2, 2, 2, 0.08);
    width: 690px;
    position: absolute;
    left: 30px;
    top: 201px;
}

.zaizhi_group_6 {
    width: 690px;
    height: 409px;
    margin-top: 30px;
}

.zaizhi_text_5 {
    width: 306px;
    height: 48px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 34px;
    white-space: nowrap;
    line-height: 48px;
    text-align: left;
    margin-left: 30px;
}

.zaizhi_list_1 {
    width: 330px;
    height: 130px;
    justify-content: space-between;
    margin: 80px 0 0 180px;
}

.zaizhi_list-items_1 {
    width: 56px;
    height: 130px;
    margin-right: 190px;
}

.zaizhi_text_6 {
    z-index: 42;
    margin-left: 5px;
    top: 0;
    width: 30px;
    height: 70px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 50px;
    white-space: nowrap;
    line-height: 70px;
    text-align: left;
}

.zaizhi_text_7 {
    z-index: 43;
    margin-left: 10px;
    top: 0;
    width: 30px;
    height: 70px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 50px;
    white-space: nowrap;
    line-height: 70px;
    text-align: left;
}

.zaizhi_text_8 {
    width: 84px;
    height: 40px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 28px;
    white-space: nowrap;
    line-height: 40px;
    text-align: left;
    margin-top: 20px;
}

.zaizhi_box_1 {
    width: 690px;
    height: 1px;
    background-color: rgba(215, 215, 215, 1);
    margin-top: 80px;
}

.zaizhi_box_2 {
    width: 640px;
    height: 40px;
    margin: 30px 0 0 20px;
}

.zaizhi_label_5 {
    width: 40px;
    height: 40px;
}

.zaizhi_text_9 {
    width: 112px;
    height: 40px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 28px;
    white-space: nowrap;
    line-height: 40px;
    text-align: left;
    margin-left: 10px;
}

.zaizhi_block_4 {
    width: 15px;
    height: 26px;
    background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/arrow.png)
        100% no-repeat;
    margin: 7px 0 0 463px;
}
</style>
